import {ThemeOptions} from '@mui/material';

import {Tokens} from '../../../../types/generated/Tokens';

export const MuiLink = ({link}: Tokens): ThemeOptions['components'] => {
  const {heading, inline, standalone} = link;

  return {
    MuiLink: {
      defaultProps: {
        variant: 'body2',
        underline: 'hover'
      },
      styleOverrides: {
        root: {
          '&.MuiTypography-h1': {
            color: heading.h1.desktop.font.color,

            '&:hover': {
              color: heading.h1.desktop.hover.font.color
            },

            '&.Mui-focusVisible': {
              outline: `${heading.h1.desktop.focus.outline.width} ${heading.h1.desktop.focus.outline.style} ${heading.h1.desktop.focus.outline.color}`
            }
          },

          '&.MuiTypography-h2': {
            color: heading.h2.desktop.font.color,

            '&:hover': {
              color: heading.h2.desktop.hover.font.color
            },

            '&.Mui-focusVisible': {
              outline: `${heading.h2.desktop.focus.outline.width} ${heading.h2.desktop.focus.outline.style} ${heading.h2.desktop.focus.outline.color}`
            }
          },

          '&.MuiTypography-h3': {
            color: heading.h3.desktop.font.color,

            '&:hover': {
              color: heading.h3.desktop.hover.font.color
            },

            '&.Mui-focusVisible': {
              outline: `${heading.h3.desktop.focus.outline.width} ${heading.h3.desktop.focus.outline.style} ${heading.h3.desktop.focus.outline.color}`
            }
          },

          '&.MuiTypography-h4': {
            color: heading.h4.desktop.font.color,

            '&:hover': {
              color: heading.h4.desktop.hover.font.color
            },

            '&.Mui-focusVisible': {
              outline: `${heading.h4.desktop.focus.outline.width} ${heading.h4.desktop.focus.outline.style} ${heading.h4.desktop.focus.outline.color}`
            }
          },

          '&.MuiTypography-h5': {
            color: heading.h5.desktop.font.color,

            '&:hover': {
              color: heading.h5.desktop.hover.font.color
            },

            '&.Mui-focusVisible': {
              outline: `${heading.h5.desktop.focus.outline.width} ${heading.h5.desktop.focus.outline.style} ${heading.h5.desktop.focus.outline.color}`
            }
          },

          '&.MuiTypography-h6': {
            color: heading.h6.desktop.font.color,

            '&:hover': {
              color: heading.h6.desktop.hover.font.color
            },

            '&.Mui-focusVisible': {
              outline: ` ${heading.h6.desktop.focus.outline.width} ${heading.h6.desktop.focus.outline.style} ${heading.h6.desktop.focus.outline.color}`
            }
          },

          '&.MuiTypography-body1, &.MuiTypography-body2': {
            color: inline.desktop.font.color,

            '&:hover': {
              color: inline.desktop.hover.font.color
            },

            '&.Mui-focusVisible': {
              outline: `${inline.desktop.focus.outline.width} ${inline.desktop.focus.outline.style} ${inline.desktop.focus.outline.color}`
            }
          },

          // =================================
          // has icon
          // =================================

          '&.has-icon': {
            alignItems: 'center',
            display: 'inline-flex'
          },
          '&.has-icon-start > .MuiSvgIcon-root': {
            marginRight: 2
          },
          '&.has-icon-end > .MuiSvgIcon-root': {
            marginLeft: 2
          },

          // =================================
          // is bold
          // =================================

          '&.is-bold': {
            fontWeight: standalone.desktop.lg.font.weight
          }
        },

        // =================================
        // underline states
        // =================================

        underlineAlways: {
          textDecoration: 'underline',

          '&:hover': {
            textDecoration: 'none'
          }
        },
        button: {
          fontWeight: 'bold'
        }
      }
    }
  };
};
